import React from 'react';
import { Grid, Card, CardContent, Typography, Box, LinearProgress } from '@mui/material';
import {
  People as PeopleIcon,
  CheckCircle as ActiveIcon,
  Warning as WarningIcon,
  Storage as CapacityIcon
} from '@mui/icons-material';

function CaseloadOverviewWidget({ summary }) {
  if (!summary) return null;

  const { caseload } = summary;

  const metrics = [
    {
      label: 'Total Clients',
      value: caseload.totalClients,
      icon: <PeopleIcon fontSize="large" />,
      color: '#1976d2'
    },
    {
      label: 'Active Clients',
      value: caseload.activeClients,
      subtitle: 'Active in last 7 days',
      icon: <ActiveIcon fontSize="large" />,
      color: '#2e7d32'
    },
    {
      label: 'Inactive Clients',
      value: caseload.inactiveClients,
      subtitle: 'No activity in 7+ days',
      icon: <WarningIcon fontSize="large" />,
      color: caseload.inactiveClients > 0 ? '#ed6c02' : '#757575'
    },
    {
      label: 'Capacity',
      value: `${caseload.totalClients}/${caseload.maxCapacity}`,
      subtitle: `${caseload.capacityUtilization}% utilized`,
      icon: <CapacityIcon fontSize="large" />,
      color: caseload.capacityUtilization > 90 ? '#d32f2f' : '#1976d2'
    }
  ];

  return (
    <Grid container spacing={2}>
      {metrics.map((metric, index) => (
        <Grid item xs={12} sm={6} md={3} key={index}>
          <Card
            sx={{
              height: '100%',
              transition: 'transform 0.2s, box-shadow 0.2s',
              '&:hover': {
                transform: 'translateY(-4px)',
                boxShadow: 4
              }
            }}
          >
            <CardContent>
              <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
                <Box sx={{ color: metric.color, opacity: 0.8 }}>
                  {metric.icon}
                </Box>
                <Typography variant="h4" fontWeight="bold" color={metric.color}>
                  {metric.value}
                </Typography>
              </Box>
              <Typography variant="body2" color="text.secondary" fontWeight="medium">
                {metric.label}
              </Typography>
              {metric.subtitle && (
                <Typography variant="caption" color="text.secondary">
                  {metric.subtitle}
                </Typography>
              )}
              {metric.label === 'Capacity' && (
                <Box mt={2}>
                  <LinearProgress
                    variant="determinate"
                    value={caseload.capacityUtilization}
                    sx={{
                      height: 8,
                      borderRadius: 4,
                      backgroundColor: '#e0e0e0',
                      '& .MuiLinearProgress-bar': {
                        backgroundColor: metric.color
                      }
                    }}
                  />
                </Box>
              )}
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
}

export default CaseloadOverviewWidget;
